import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CallListingShape from 'app/shapes/CallListingShape';
import GTMUtility from 'app/util/gtmUtil';
import {
  Box,
  Typography,
} from '@mui/material';

import CallFailed from 'app/components/call/callInProgress/Icons/CallFailed';
import CallNowActionButton from 'app/components/call/CallNowActionButton';

const AdvisorTimeoutStep = ({
  listing,
  triggerCall,
}) => {
  useEffect(() => {
    GTMUtility.sendEvent('call_advisor_timeout_step', { version: 'redesign' });
  }, []);

  return (
    <Box textAlign="center">
      <Box mt={3} mb={3}>
        <CallFailed />
      </Box>
      <Typography variant="body1" gutterBottom>
        {`${listing.login} is currently unavailable.`}
      </Typography>
      <CallNowActionButton
        gtmCallState="advisor-timeout"
        canCall
        listing={listing}
        triggerCall={triggerCall}
        hideErrorMessage
      />
    </Box>
  );
};

AdvisorTimeoutStep.defaultProps = {
};

AdvisorTimeoutStep.propTypes = {
  listing: CallListingShape.isRequired,
  triggerCall: PropTypes.func.isRequired,
};

export default AdvisorTimeoutStep;
